import "./App.css";
import CrnaKarta from "./CrnaKarta";
import { useData } from "./useData";

function App() {
  var topoData = require("./opcine.topo.json");

  const urls = {
    // 2011: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQzx1Hq-ikPUbWQEmVOz2wwhJoJGtkzDC-MVCu50IXFYbCNxgiJf3hDDfYcf6_NKw/pub?output=csv&gid=200568817",
    // 2021: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTQSe5bO6A7_dgCf8Xnn0gZgOYX96sfGMco_Lnqxca57bEV_wmsWHGHvwhqPxKP0w/pub?output=csv&gid=17409117",
    2011: "dzs_2011.csv",
    2021: "popis2021.csv"
  };

  const { censusData, loading } = useData(urls);

  return <div className="container">
    {loading && <div className="loading">Loading data, please wait...</div>}
    {!loading && <CrnaKarta topoData={topoData} censusData={censusData}></CrnaKarta>}
  </div>

}

export default App;
